export default __webpack_public_path__ + "static/media/Group_343.6044918b.jpg";